import Link from 'next/link'
import React from 'react'

import { Avatar } from '@wartek-id/avatar'
import { Button } from '@wartek-id/button'
import { Icon } from '@wartek-id/icon'
import { Popover, PopoverContent, PopoverTrigger } from '@wartek-id/popover'
import { Text } from '@wartek-id/text'

import { useAuth } from 'utils/hooks/useAuth'
import { useRegionContext } from 'utils/hooks/useRegion'
import { useRoles } from 'utils/hooks/useRoles'

const UserDetails = () => {
  const { bcksUserSession } = useAuth()
  const { activeRoleName, hasConflictingRoles } = useRoles()
  const { user = null } = bcksUserSession || {}
  const { regionDetail } = useRegionContext()

  return (
    <Popover offset={[0, 14]} className="flex items-center">
      <PopoverTrigger className="flex items-center">
        <Avatar src={user?.picture} alt={user?.name} />
        <Icon className="ml-2">expand_more</Icon>
      </PopoverTrigger>

      <PopoverContent className="mt-4 min-w-[300px]">
        <div className="p-4">
          <div className="mb-4">
            <Text variant="action" className="mb-1">
              {user?.name}
            </Text>
            <Text
              variant="body-sm"
              color="subdued"
              className="overflow-hidden text-ellipsis"
            >
              {user?.email}
            </Text>
          </div>

          <div className="mb-4 space-y-1 rounded bg-surface-informational-subdued p-2.5">
            <div className="flex justify-between gap-2">
              <Text variant="body-sm-bold" color="primary">
                Peran:
              </Text>
              <Text variant="body-sm" color="primary" className="uppercase">
                {hasConflictingRoles ? '-' : activeRoleName || '-'}
              </Text>
            </div>

            <div className="flex justify-between gap-2">
              <Text variant="body-sm-bold" color="primary">
                Wilayah:
              </Text>
              <Text variant="body-sm" color="primary" className="uppercase">
                {regionDetail.name || '-'}
              </Text>
            </div>
          </div>

          <Link href="/logout">
            <Button fullWidth>
              <Icon fontSize="sm" color="inverse" className="mr-1">
                logout
              </Icon>
              Keluar
            </Button>
          </Link>
        </div>
      </PopoverContent>
    </Popover>
  )
}

export default UserDetails
